import React from 'react';
import Container from "../layout/Container";
import partner from "../../_asset/media/partner.png"

function Footer() {
    return (
        <footer id={"main-footer"}>
            <Container>
                <img src={partner} alt="partner" />
                <div className={"footer-bot"}>
                    <p className={`footer-copylight`}>Copyright ⓒ 2025 ZEUS CASINO All Rights Reserved.</p>
                </div>
            </Container>
        </footer>
    );
}

export default Footer;